import { combineReducers } from 'redux';
import UnitHome from './UnitHome';
import Ticket from './Ticket';

export default combineReducers({
  UnitHome,
  Ticket,
});
